import { LocalizedPricingData } from '~/networking/models/PortfolioPricingData';

import { UserHorizon } from '../../requests';

export enum FundingStatus {
    Liquidating = 'liquidating',
    Inactive = 'inactive',
    Active = 'active'
}

/**
 * Response of httpRequests to GET v1/portfolio/{portfolioID}
 */
export interface GetUserPortfolioResponse {
    id: string;
    liquidationFlowIntent: string;
    autoBuyDisabled: boolean;
    investmentStyle: string;
    isWithdrawalEligible: boolean;
    horizon: UserHorizon;
    status: FundingStatus;
    cash: {
        amount: number;
        currency: string;
    };
    bottleCount: number;
    assetCount: number;
    costBasis: {
        amount: number;
        currency: string;
    };
    positionTotal: {
        amount: number;
        currency: string;
    };
    positionTotalPercentage: string;
    planLevel: string;
    rebalanceEnabled: boolean;
    returns: {
        netChange: {
            amount: number;
            currency: string;
        };
        fees: {
            amount: number;
            currency: string;
        };
        ytdNetChange: {
            amount: number;
            currency: string;
        };
        ytdFees: {
            amount: number;
            currency: string;
        };
    };
    regionAllocation: {
        percentage: number;
        region: string;
    }[];
    totalHistory: {
        pricing: LocalizedPricingData;
        currency: string;
    };
    withdrawalCashBalance: {
        amount: number;
        currency: string;
    };
}
